import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTypographyCase12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconTypographyCase12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.5 1h-1a.5.5 0 0 0-.5.5V3h2V1.5a.5.5 0 0 0-.5-.5M4 1.5V3H1.5A1.5 1.5 0 0 0 0 4.5v5A1.5 1.5 0 0 0 1.5 11h9A1.5 1.5 0 0 0 12 9.5v-5A1.5 1.5 0 0 0 10.5 3H8V1.5A1.5 1.5 0 0 0 6.5 0h-1A1.5 1.5 0 0 0 4 1.5M7 4h3.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5zM4 5h-.5v1.5a.5.5 0 0 0 1 0V6h1v2H5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-.5V6h1v.5a.5.5 0 0 0 1 0V5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTypographyCase12);
